import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const trackEvent = (name, props = {}) => {
  api.post("/analytics/event", { name, props }).catch(() => {});
};

export default api;
